<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>虚拟商品码池</span>
      <el-button
        v-if="$hasPermission('mall:virtual-code:upload', 'mall:virtual-code:list')"
        type="primary"
        size="mini"
        @click="openUpload"
      >
        上传码包
      </el-button>
    </div>

    <div class="summary-grid">
      <div class="summary-card">
        <div class="summary-label">码总数</div>
        <div class="summary-value">{{ summary.total || 0 }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">未发放</div>
        <div class="summary-value available">{{ summary.available || 0 }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">已发放</div>
        <div class="summary-value issued">{{ summary.issued || 0 }}</div>
      </div>
    </div>

    <div class="search-bar">
      <el-select v-model="query.goodsId" clearable filterable placeholder="选择虚拟商品" style="width: 240px" @change="handleSearch">
        <el-option v-for="item in virtualGoodsOptions" :key="item.id" :label="item.goodsName" :value="item.id" />
      </el-select>
      <el-select v-model="query.issuedStatus" clearable placeholder="发放状态" style="width: 140px" @change="handleSearch">
        <el-option :value="0" label="未发放" />
        <el-option :value="1" label="已发放" />
      </el-select>
      <el-input
        v-model.trim="query.keyword"
        placeholder="请输入CDK或订单号"
        clearable
        style="width: 240px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-alert
      title="批量删除需要先勾选左侧未发放CDK；已发放CDK为保护兑换记录，不能批量选择或删除。"
      type="info"
      :closable="false"
      show-icon
      class="batch-tip"
    />

    <el-table :data="list" border style="width: 100%" @selection-change="selection = $event">
      <el-table-column type="selection" width="55" :selectable="row => Number(row.issuedStatus) === 0" />
      <el-table-column prop="cdkCode" label="CDK码" min-width="220" show-overflow-tooltip />
      <el-table-column prop="goodsName" label="对应虚拟商品" min-width="180" show-overflow-tooltip />
      <el-table-column label="是否发放" width="110">
        <template slot-scope="{ row }">
          <el-tag :type="Number(row.issuedStatus) === 1 ? 'success' : 'info'" size="mini">
            {{ Number(row.issuedStatus) === 1 ? '已发放' : '未发放' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" label="关联订单" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.orderNo || '-' }}</template>
      </el-table-column>
      <el-table-column prop="issuedTime" label="发放时间" width="170">
        <template slot-scope="{ row }">{{ row.issuedTime || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="导入时间" width="170" />
      <el-table-column label="操作" width="110" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="$hasPermission('mall:virtual-code:delete', 'mall:virtual-code:list')"
            size="mini"
            type="danger"
            :disabled="Number(row.issuedStatus) === 1"
            @click="remove([row.id])"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-actions">
      <el-tooltip
        v-if="$hasPermission('mall:virtual-code:delete', 'mall:virtual-code:list')"
        :disabled="selection.length > 0"
        content="请先勾选表格左侧的未发放CDK"
        placement="top"
      >
        <span class="action-button-wrap">
          <el-button
            size="mini"
            type="danger"
            :disabled="!selection.length"
            @click="remove(selection.map(item => item.id))"
          >
            {{ batchDeleteText }}
          </el-button>
        </span>
      </el-tooltip>
    </div>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog title="上传TXT码包" :visible.sync="uploadVisible" width="640px" :close-on-click-modal="false">
      <el-form label-width="110px">
        <el-form-item label="虚拟商品">
          <el-select v-model="uploadForm.goodsId" clearable filterable placeholder="单商品码包可选择；混合码包可不选" style="width: 100%">
            <el-option v-for="item in virtualGoodsOptions" :key="item.id" :label="item.goodsName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="TXT码包">
          <el-upload
            ref="uploadRef"
            action="#"
            :auto-upload="false"
            :limit="1"
            accept=".txt,text/plain"
            :file-list="fileList"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
          >
            <el-button size="mini" type="primary">选择TXT文件</el-button>
            <div slot="tip" class="el-upload__tip">
              支持两种格式：单商品每行一个CDK；混合上传每行“商品标识,CDK码”，商品标识支持商品ID、商品编号或商品名称任意一种，例如“1001,YOUKU-ABC-001”。
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadVisible = false">取消</el-button>
        <el-button type="primary" :loading="uploading" @click="submitUpload">开始上传</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    goodsId: null,
    issuedStatus: null,
    keyword: ''
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      list: [],
      total: 0,
      summary: {},
      goodsOptions: [],
      selection: [],
      uploadVisible: false,
      uploading: false,
      uploadForm: {
        goodsId: null
      },
      fileList: []
    }
  },
  computed: {
    virtualGoodsOptions () {
      return this.goodsOptions.filter(item => Number(item.goodsType) === 2)
    },
    batchDeleteText () {
      return this.selection.length ? '批量删除已选 ' + this.selection.length + ' 条' : '请先勾选未发放CDK'
    }
  },
  created () {
    this.loadGoodsOptions()
    this.refresh()
  },
  methods: {
    async refresh () {
      await Promise.all([this.load(), this.loadSummary()])
    },
    async load () {
      const { data } = await http.get('/mall/virtual-code/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    async loadSummary () {
      const params = {}
      if (this.query.goodsId) params.goodsId = this.query.goodsId
      const { data } = await http.get('/mall/virtual-code/summary', { params })
      this.summary = data.data || {}
    },
    async loadGoodsOptions () {
      const { data } = await http.get('/mall/goods/options')
      this.goodsOptions = data.data || []
    },
    handleSearch () {
      this.query.page = 1
      this.refresh()
    },
    reset () {
      this.query = defaultQuery()
      this.refresh()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    openUpload () {
      this.uploadForm = { goodsId: this.query.goodsId || null }
      this.fileList = []
      this.uploadVisible = true
    },
    handleFileChange (file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
    },
    async submitUpload () {
      if (!this.fileList.length) {
        this.$message.warning('请选择TXT码包')
        return
      }
      const formData = new FormData()
      if (this.uploadForm.goodsId) {
        formData.append('goodsId', this.uploadForm.goodsId)
      }
      formData.append('file', this.fileList[0].raw)
      this.uploading = true
      try {
        const { data } = await http.post('/mall/virtual-code/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (data.code === 0) {
          const result = data.data || {}
          this.$message.success(`导入成功 ${result.success || 0} 条，重复 ${result.duplicate || 0} 条`)
          this.uploadVisible = false
          this.query.goodsId = this.uploadForm.goodsId || null
          await this.refresh()
        }
      } finally {
        this.uploading = false
      }
    },
    remove (ids) {
      if (!ids || !ids.length) return
      this.$confirm('确认删除选中的未发放CDK吗？删除后不可恢复。', '删除确认', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/virtual-code/delete', ids)
        if (data.code === 0) {
          this.$message.success('删除成功')
          await this.refresh()
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.summary-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
  border: 1px solid #e5edf7;
}

.summary-label {
  color: #64748b;
  font-size: 13px;
}

.summary-value {
  margin-top: 8px;
  color: #1f2937;
  font-size: 24px;
  font-weight: 700;
}

.summary-value.available {
  color: #16a34a;
}

.summary-value.issued {
  color: #2563eb;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.batch-tip {
  margin-bottom: 12px;
}

.table-actions {
  margin-top: 12px;
}

.action-button-wrap {
  display: inline-block;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
